import { useState, useCallback } from 'react';
import { tiposEstudiosAPI } from '../../../core/api/api';

export const useTiposEstudiosExt = () => {
  const [tiposEstudiosExt, setTiposEstudiosExt] = useState([]);
  const [loading, setLoading] = useState(false);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await tiposEstudiosAPI.getTiposEstudiosExt();
      setTiposEstudiosExt(res.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  const guardar = useCallback(async (tipoEstudioExt) => {
    setLoading(true);
    try { await tiposEstudiosAPI.guardarTipoEstudioExt(tipoEstudioExt); }
    finally { setLoading(false); }
  }, []);

  const actualizar = useCallback(async (id, tipoEstudioExt) => {
    setLoading(true);
    try { await tiposEstudiosAPI.actualizarTipoEstudioExt(id, tipoEstudioExt); }
    finally { setLoading(false); }
  }, []);

  const eliminar = useCallback(async (id) => {
    setLoading(true);
    try { await tiposEstudiosAPI.eliminarTipoEstudioExt(id); }
    finally { setLoading(false); }
  }, []);

  return { tiposEstudiosExt, loading, cargar, guardar, actualizar, eliminar };
};
